module.exports = __webpack_public_path__ + "static/media/orange-arrow-yellow.7af186fc.svg";